var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"lost-view"}},[_c('h1',[_vm._v("Cette page n'a pas été trouvée")]),_vm._v(" "),_c('h4',[_vm._v("Nous sommes désolés, mais la page demandée est introuvable.")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Retour à l'accueil")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2e600b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Lost.vue
// module id = null
// module chunks = 